/* HALE — the ONE cart counter: header «Кошик (N)» + mobile tab-bar badge.
   Phase 1 (2026-09-08): a plain subscriber of the cart store. No fetch, no
   monkey-patched window.fetch — the store owns the state.
   Phase B (2026-09-13): the only writer. Before, three scripts painted the
   same number: this file rewrote the whole <span> of the header link (and
   with it destroyed the <b data-hale-cart-count> the header's own inline
   subscriber was looking for), hale-header.liquid painted
   [data-hale-cart-count], hale-mobile.liquid painted [data-mcart-count].
   Now: [data-hale-cart-count] (header) and [data-mcart-count] (tab bar) are
   painted here and nowhere else. */
(function(){
  'use strict';
  function paint(n){
    document.querySelectorAll('[data-hale-cart-count]').forEach(function(el){
      if(el.textContent !== String(n)) el.textContent = n;
    });
    document.querySelectorAll('[data-mcart-count]').forEach(function(el){
      var prev = parseInt(el.textContent, 10) || 0;
      el.textContent = n;
      if(n > 0){
        el.removeAttribute('hidden');
        if(n !== prev){ el.classList.add('bump'); setTimeout(function(){ el.classList.remove('bump'); }, 420); }
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }
  window.HALE.ready(function(){
    var H = window.HALE;
    paint(H.cart.count());
    H.on('hale:cart', function(e){ paint(e.detail.count); });
    /* back/forward cache: the page comes back with the cart it left with */
    window.addEventListener('pageshow', function(e){ if(e.persisted) H.cart.refresh('pageshow'); });
  });
})();
